import {
  acceptKariShinsei,
  copyShinsei,
  deleteShinsei,
  kariShinsei,
  rejectKariShinsei,
  saveShinsei,
  shinsei,
} from "@/api/shinsei.api";
import { ComfirmMsg, ConfirmText, InfoMsg } from "@/constants/message.constant";
import { shinseiModel, shoninModel } from "@/interfaces/shinsei.interface";
import { ElMessage, ElMessageBox } from "element-plus";
import { h, Ref } from "vue";
import { useRouter } from "vue-router";
import { Buttons } from "./config";

export function handleShinseishaButtons(
  shinseiFormRef: Ref<any>,
  panels: {
    shinseiInfo: any;
    shinseishaInfo: any;
    shoninshaInfo: any;
    shinseiForm: shinseiModel;
    shoninForm: shoninModel;
  },
  handleReload: (id?: string) => void,
  loadings: Buttons,
  checkFileds: string[]
) {
  const router = useRouter();
  //複写と一時保存の時、開始日と終了日はチェックしない
  const filedsExceptKikan = checkFileds.filter(
    (item) => item !== "kikanKaishibi" && item !== "kikanShuryobi"
  );
  const generateShinseiData = () => {
    const data: shinseiModel = Object.assign(
      {
        id: panels.shinseiInfo.id,
        shinseiId: panels.shinseiInfo.shinseiId,
        kigyonaiShinchokuCdShinsei: panels.shinseiInfo.shinchokuCdShinsei,
        kigyonaiShinchokuCdShonin: panels.shinseiInfo.shinchokuCdShonin,
        statusCd: panels.shinseiInfo.statusCd,
      },
      panels.shinseiForm
    );
    return data;
  };
  //申請内容欄の利用項目と利用範囲の「その他」チェックがFALSEの場合、「その他」テキストを空に
  const clearSonohokaText = () => {
    const shinseiForm = panels.shinseiForm;
    if (!shinseiForm.riyokomokuSonohokaFlg) {
      shinseiForm.riyokomokuSonohokaText = "";
    }
    if (!shinseiForm.riyohaniSonohokaFlg) {
      shinseiForm.riyohaniSonohokaText = "";
    }
  };
  //仮申請、申請などの申請者処理が行われる直前にやる処理
  const beforeShinseishaButtonsAction = () => {
    clearSonohokaText();
  };
  //申請ボタン押下
  const handleShinsei = () => {
    shinseiFormRef.value?.validate(async (valid: unknown) => {
      if (valid) {
        loadings.shinseiBtn = true;
        ElMessageBox({
          title: ConfirmText.TITLE,
          message: ComfirmMsg.CFM_SHINSEI,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: ConfirmText.YES,
          cancelButtonText: ConfirmText.NO,
        })
          .then(async () => {
            beforeShinseishaButtonsAction();
            const data = generateShinseiData();
            const {
              data: { result },
            } = await shinsei(data);
            ElMessage({
              type: "success",
              message: InfoMsg.INFO_SHINSEI_COMPLETED,
            });
            loadings.shinseiBtn = false;
            handleReload(result.id);
          })
          .catch(() => {
            loadings.shinseiBtn = false;
          });
      } else {
        return false;
      }
    });
  };
  //仮申請ボタン押下
  const handleKariShinsei = () => {
    shinseiFormRef.value?.validate(async (valid: unknown) => {
      if (valid) {
        loadings.kariShinseiBtn = true;
        ElMessageBox({
          title: ConfirmText.TITLE,
          message: ComfirmMsg.CFM_KARI_SHINSEI,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: ConfirmText.YES,
          cancelButtonText: ConfirmText.NO,
        })
          .then(async () => {
            beforeShinseishaButtonsAction();
            const data = generateShinseiData();
            const {
              data: { result },
            } = await kariShinsei(data);
            ElMessage({
              type: "success",
              message: InfoMsg.INFO_KARI_SHINSEI_COMPLETED,
            });
            loadings.kariShinseiBtn = false;
            handleReload(result.id);
          })
          .catch(() => {
            loadings.kariShinseiBtn = false;
          });
      } else {
        return false;
      }
    });
  };
  //仮申請を承認ボタン押下
  const handleShinseiOk = () => {
    shinseiFormRef.value?.validate(async (valid: unknown) => {
      if (valid) {
        loadings.kariShinseiOkBtn = true;
        ElMessageBox({
          title: ConfirmText.TITLE,
          message: ComfirmMsg.CFM_SHINSEI,
          type: "success",
          showCancelButton: true,
          confirmButtonText: ConfirmText.YES,
          cancelButtonText: ConfirmText.NO,
        })
          .then(async () => {
            beforeShinseishaButtonsAction();
            const data = generateShinseiData();
            const {
              data: { result },
            } = await acceptKariShinsei(data);
            ElMessage({
              type: "success",
              message: InfoMsg.INFO_SHINSEI_COMPLETED,
            });
            loadings.kariShinseiOkBtn = false;
            handleReload();
          })
          .catch(() => {
            loadings.kariShinseiOkBtn = false;
          });
      } else {
        return false;
      }
    });
  };
  //仮申請を却下ボタン押下
  const handleShinseiNg = () => {
    shinseiFormRef.value?.validate(async (valid: unknown) => {
      if (valid) {
        loadings.kariShinseiNgBtn = true;
        ElMessageBox({
          title: ConfirmText.TITLE,
          message: ComfirmMsg.CFM_TORIKESI,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: ConfirmText.YES,
          cancelButtonText: ConfirmText.NO,
        })
          .then(async () => {
            beforeShinseishaButtonsAction();
            const data = generateShinseiData();
            await rejectKariShinsei(data);
            ElMessage({
              type: "success",
              message: InfoMsg.INFO_TORIKESI_COMPLETED,
            });
            loadings.kariShinseiNgBtn = false;
            handleReload();
          })
          .catch(() => {
            loadings.kariShinseiNgBtn = false;
          });
      } else {
        return false;
      }
    });
  };
  //一時保存ボタン押下
  const handleSaveShinsei = () => {
    let errorMsgs = "";
    shinseiFormRef.value?.validateField(filedsExceptKikan, (msg: string) => {
      errorMsgs += msg;
    });
    if (errorMsgs) {
      return;
    }
    loadings.saveBtn = true;
    ElMessageBox({
      title: ConfirmText.TITLE,
      message: ComfirmMsg.CFM_SAVE,
      type: "warning",
      showCancelButton: true,
      confirmButtonText: ConfirmText.YES,
      cancelButtonText: ConfirmText.NO,
    })
      .then(async () => {
        beforeShinseishaButtonsAction();
        const data = generateShinseiData();
        const {
          data: { result },
        } = await saveShinsei(data);
        ElMessage({
          type: "success",
          message: InfoMsg.INFO_SAVE_COMPLETED,
        });
        loadings.saveBtn = false;
        handleReload(result.id);
      })
      .catch(() => {
        loadings.saveBtn = false;
      });
  };
  //複写ボタン押下
  const handleCopyShinsei = () => {
    let errorMsgs = "";
    shinseiFormRef.value?.validateField(filedsExceptKikan, (msg: string) => {
      errorMsgs += msg;
    });
    if (errorMsgs) {
      return;
    }
    loadings.copyBtn = true;
    let copyTargetPage: Window;
    ElMessageBox({
      title: ConfirmText.TITLE,
      message: ComfirmMsg.CFM_COPY,
      type: "warning",
      showCancelButton: true,
      confirmButtonText: ConfirmText.YES,
      cancelButtonText: ConfirmText.NO,
    })
      .then(async () => {
        beforeShinseishaButtonsAction();
        /* 
                新しいタブを開いておく。
                必ずタブを開いてからAPIリクエストを送る。じゃないと、firefoxで新しいタブがブロックされる。
                 */
        copyTargetPage = window.open("about:blank") as Window;
        const data = generateShinseiData();
        const {
          data: { result },
        } = await copyShinsei(data);
        ElMessage({
          type: "success",
          message: InfoMsg.INFO_COPY_COMPLETED,
        });
        loadings.copyBtn = false;
        const routeData = router.resolve({
          name: "shinseiDetail",
          params: { id: result.id },
        });
        //新しいタブに複写先hrefをセット。
        copyTargetPage.location.href = routeData.href;
      })
      .catch(() => {
        loadings.copyBtn = false;
        copyTargetPage.close();
      });
  };
  //削除ボタン押下
  const handleDeleteShinsei = () => {
    loadings.deleteBtn = true;
    ElMessageBox({
      title: ConfirmText.TITLE,
      message: h("p", null, [
        h(
          "p",
          { style: "color: #b87d11" },
          "申請ID：" + panels.shinseiInfo.shinseiId
        ),
        h(
          "p",
          { style: "color: #b87d11" },
          "ステータス：" + panels.shinseiInfo.status
        ),
        h("span", null, ComfirmMsg.CFM_DELETE),
      ]),
      type: "warning",
      showCancelButton: true,
      confirmButtonText: ConfirmText.YES,
      cancelButtonText: ConfirmText.NO,
    })
      .then(async () => {
        const data = generateShinseiData();
        await deleteShinsei(data);
        ElMessage({
          type: "success",
          message: InfoMsg.INFO_DELETE_COMPLETED,
        });
        loadings.deleteBtn = false;
        router.push({ name: "shinseiList" });
      })
      .catch(() => {
        loadings.deleteBtn = false;
      });
  };
  return {
    handleShinsei,
    handleKariShinsei,
    handleShinseiOk,
    handleShinseiNg,
    handleSaveShinsei,
    handleCopyShinsei,
    handleDeleteShinsei,
  };
}
